let http = {};
import axios from 'axios';
import utils from './utils';

// 自定义异常处理方式
function custErrStatusFun(vm, errStatus, errMsg) {
    utils.hideLoading(vm);
    switch (errStatus) {
        case 404:
            utils.error(errMsg || '404')
            break;
        case 403:
            utils.error(errMsg || '没有权限');
            vm.$router.push({
                name: 'login'
            })
            break;
        default:
            utils.error(errMsg || '请求失败')

    }
}

// 自定义异常处理方式
function custErrFun(vm, err) {
    if (err.status == 500 || (err.response && err.response.status == 500)) {
        utils.hideLoading(vm);
        utils.error('请求失败');
    } else if (err.response && err.response.status !== 200) {
        if (err.response.status == 403) {
            vm.$router.push({
                name: 'login'
            })
            utils.hideLoading(vm);
        } else {
            utils.hideLoading(vm);
            utils.error(err.response.data.msg || '请求失败');
        }
    }
    else if (err.message && err.stack) {
        console.log(err);
    } else {
        // TODO 超时处理机制
        // 请求返回的异常
        var errStatus = err.response.status;
        custErrStatusFun(vm, errStatus);

    }
}


// 自定义返回处理
function custResponseFun(vm, res, resolve) {
    // 返回的状态
    const responseStatus = res.data.status;
    const responseMsg = res.data.msg || res.data.messageList;
    switch (responseStatus) {
        case 200:
            resolve(res);
            break;
        default:
            custErrStatusFun(vm, responseStatus, responseMsg);
    }
}

// get 请求
http.get = function(vm, url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params || {},
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'authorization': vm.$store.state.token
                },
                timeout: 60000
            })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};


// POST 请求
http.post = function(vm, url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'authorization': vm.$store.state.token
                },
                timeout: 60000
            })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

http.postFormData = function(vm, url, params) {
    return new Promise((resolve, reject) => {

        axios.post(url, params, {
                headers: {
                    'Content-Type': 'multipart/form-data;charset=UTF-8',
                    'authorization': vm.$store.state.token
                },
                timeout: 60000
            })
            .then(res => {
                custResponseFun(vm, res, resolve);
            })
            .catch(err => {
                custErrFun(vm, err);
            })
    });
};

export default http;